import type { ReactNode } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button } from 'uikit/buttons/default'
import { Popover } from 'uikit/tooltips/popover/popover'
import { Tooltip } from 'uikit/tooltips/default'
import { Collapse } from 'uikit/Collapse/Collapse'
import styles from './graph-help-button.module.scss'

export interface HelpSection {
  key: string
  label: string
  children: ReactNode
}

interface GraphHelpButtonProps {
  title: string
  sections: HelpSection[]
}

const collapseItemStyles = { header: { paddingInlineStart: 0 }, body: { paddingTop: 0, paddingBottom: 4 } }

export function GraphHelpButton({ title, sections }: GraphHelpButtonProps) {
  const popoverContent = (
    <div className={styles.popoverContent}>
      <Collapse
        accordion
        items={sections.map(section => ({ ...section, styles: collapseItemStyles }))}
        size='small'
        ghost
      />
    </div>
  )

  return (
    <div className={styles.container}>
      <Popover content={popoverContent} title={title} trigger='click' placement='rightTop'>
        <Tooltip title='Help'>
          <Button type='default' icon={<QuestionCircleOutlined />} />
        </Tooltip>
      </Popover>
    </div>
  )
}
